import { z } from 'zod'
import {
  authUserSchema,
  loginResponseSchema,
  tokenPairSchema,
  type LoginRequest,
  type RefreshRequest,
} from '@contracts/auth'
import type { HttpClient } from '@/shared/api'

/** Endpoint functions of the backend's auth contract (contracts/auth.ts). */
export function createAuthApi(http: HttpClient) {
  return {
    login: (body: LoginRequest) =>
      http.post('/auth/login', { schema: loginResponseSchema, body, auth: false }),
    /** Called only by the SessionRenewer: a refresh token works once. */
    refresh: (body: RefreshRequest) =>
      http.post('/auth/refresh', { schema: tokenPairSchema, body, auth: false }),
    logout: (body: RefreshRequest) =>
      http.post('/auth/logout', { schema: z.undefined(), body, auth: false }),
    me: (signal?: AbortSignal) => http.get('/auth/me', { schema: authUserSchema, signal }),
  }
}

export type AuthApi = ReturnType<typeof createAuthApi>
